import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import unileverLogo from '../../../assets/images/logo/uni-New-Logo.png';
import AreaService from '../../../api/areaService';
import { errorToast, successToast } from '../../../_helper/helper';

const ViolationPage = () => {
  const { id: routeId } = useParams();
  const [searchParams] = useSearchParams();
  const [comment, setComment] = useState('');
  const [violatorName, setViolatorName] = useState('');
  const [tokenNumber, setTokenNumber] = useState('');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(true);
  const [alertData, setAlertData] = useState(null);
  const [showfinalMsg, setshowfinalMsg] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch alert detail for picture and metadata
  useEffect(() => {
    const alertId = routeId || searchParams.get('id');
    if (!alertId) return;

    const fetchDetail = async () => {
      try {
        setLoading(true);
        const id = Number(alertId) || alertId;
        console.log('get_alert_detail operation_safety_id:', id);
        const res = await AreaService.get_alert_detail(id);
        const data = res?.data?.data || res?.data || null;
        setAlertData(data);
      } catch (err) {
        // Surface server response details if present
        if (err?.response) {
          console.error('Failed to fetch alert detail', err.response.status, err.response.data);
        } else {
          console.error('Failed to fetch alert detail', err?.message || err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [routeId, searchParams]);

  const getFirstAvailable = (obj, keys = []) => {
    if (!obj) return undefined;
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
    }
    return undefined;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const alertId = routeId || searchParams.get('id'); 
    try {
      const payload = {
        id: alertId,
        acknowledge: alertData?.acknowledge,
        supervisor: true,
        detail: comment,
        violator_name: violatorName,
        token_number: tokenNumber,
      };
      const res = await AreaService.update_alert_acknowledge(payload);
      console.log(res)
      if(res.data){
        successToast('Comment added successfully');
        setshowfinalMsg(true)
      }
      console.log('Acknowledgement updated successfully');
    } catch (err) { 
      console.error(err.response.data.message); 
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8f9fa',
      padding: '20px 0'
    }}>
      {/* Unilever Logo at top center */}
      <div style={{ 
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        zIndex: 1000,
        backgroundColor: '#f8f9fa',
        padding: '15px 0',
        textAlign: 'center'
      }}>
        <img 
          src={unileverLogo} 
          alt="Unilever Logo" 
          style={{ 
            height: windowWidth < 768 ? '60px' : '100px',
            maxWidth: windowWidth < 768 ? '200px' : '300px'
          }}
        />
      </div>

      <Container style={{ paddingTop: windowWidth < 768 ? '120px' : '140px' }}>
        {/* Title */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '40px' 
        }}>
          <h1 style={{ 
            color: '#2c3e50',
            fontWeight: 'bold',
            fontSize: windowWidth < 768 ? '1.8rem' : windowWidth < 1024 ? '2.2rem' : '2.5rem'
          }}>
            Safety Violation Report
          </h1>
        </div>
          {
            showfinalMsg ? <div className='d-flex justify-content-center align-items-center h-100 '>
              <div className="text-center px-4 py-3 b-r-10" style={{ 
                color:"#1e346b",
                // border:"1px solid #d4d4d4ff",
                backgroundColor: '#fff'
              }}>
                <img src="https://i.pinimg.com/originals/57/b5/48/57b54818e2011d482548fb54201ce6c1.gif" alt="Confirmation" width={200} />
              <h3>Thank you for your submission!</h3>
              </div>

            </div> :
        <Row className="justify-content-center">
          <Col lg="10">
            <Row>
              {/* Left side - Picture */}
              <Col xs="12" md="6">
                <Card style={{ 
                  height: windowWidth < 768 ? '300px' : '500px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#e9ecef',
                  border: '2px dashed #6c757d'
                }}>
                  <CardBody className="text-center" style={{ height: '100%', width: '100%', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {loading ? (
                      <p>Loading image…</p>
                    ) : (
                      (() => {
                        const imgSrc = getFirstAvailable(alertData, [
                          'image',
                          'image_url',
                          'imageUrl',
                          'alert_img_path',
                          'img',
                          'image_path',
                          'picture'
                        ]);
                        return imgSrc ? (
                          <img
                            src={imgSrc}
                            alt="Violation"
                            style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center center' }}
                          />
                        ) : (
                          <>
                            <div style={{ fontSize: '4rem', color: '#6c757d', marginBottom: '20px' }}>📷</div>
                            <p style={{ color: '#6c757d', fontSize: '1.1rem', margin: 0 }}>No image available</p>
                          </>
                        );
                      })()
                    )}
    
                  </CardBody>
                </Card>
              </Col>

              {/* Right side - Details */}
              <Col xs="12" md="6">
                <Card style={{ 
                  height: windowWidth < 768 ? 'auto' : '500px', 
                  minHeight: windowWidth < 768 ? '300px' : '500px'
                }}>
                  <CardBody>
                    <h4 style={{ 
                      color: '#2c3e50',
                      marginBottom: '20px',
                      borderBottom: '2px solid #007bff',
                      paddingBottom: '10px'
                    }}>
                      Violation Details
                    </h4>
                    {loading ? (
                      <p>Loading details…</p>
                    ) : (
                      <>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Operation ID:</strong> <span style={{ color: '#6c757d' }}>{alertData?.operation_safety_id || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Module:</strong> <span style={{ color: '#6c757d' }}>{alertData?.module || alertData?.violation || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Violation:</strong> <span style={{ color: '#6c757d' }}>{alertData?.violation || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Severity:</strong> <span style={{ color: '#fd7e14' }}>{alertData?.VioSeverity || alertData?.severity || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Date:</strong> <span style={{ color: '#6c757d' }}>{alertData?.date || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Time:</strong> <span style={{ color: '#6c757d' }}>{alertData?.time || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Shift:</strong> <span style={{ color: '#6c757d' }}>{alertData?.shift || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Camera:</strong> <span style={{ color: '#6c757d' }}>{alertData?.camera_name || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Camera ID:</strong> <span style={{ color: '#6c757d' }}>{alertData?.camera_id || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Area:</strong> <span style={{ color: '#6c757d' }}>{alertData?.area || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Area Owner:</strong> <span style={{ color: '#6c757d' }}>{alertData?.area_owner || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Sub Area:</strong> <span style={{ color: '#6c757d' }}>{alertData?.subarea || alertData?.sub_area || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Violation Area:</strong> <span style={{ color: '#6c757d' }}>{alertData?.violationArea || 'N/A'}</span>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <strong>Acknowledged:</strong> <span style={{ color: '#6c757d' }}>{String(alertData?.acknowledge ?? 'N/A')}</span>
                        </div>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Comment Box */}
            <Row className="mt-4 justify-content-center">
              <Col xs="12" lg="10"> 
                <Card>
                  <CardBody>
                    <Form onSubmit={handleSubmit}>
                      <FormGroup>
                        <Label htmlFor="violatorName" style={{ 
                          fontWeight: 'bold',
                          color: '#2c3e50',
                          marginBottom: '10px'
                        }}>
                          Violator Name
                        </Label>
                        <Input
                          type="text"
                          name="violatorName"
                          id="violatorName"
                          placeholder="Enter violator's full name"
                          value={violatorName}
                          onChange={(e) => setViolatorName(e.target.value)}
                          style={{
                            border: '1px solid #ced4da',
                            borderRadius: '8px',
                            fontSize: '1rem'
                          }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="tokenNumber" style={{ 
                          fontWeight: 'bold',
                          color: '#2c3e50',
                          marginBottom: '10px'
                        }}>
                          Token Number
                        </Label>
                        <Input
                          type="text"
                          name="tokenNumber"
                          id="tokenNumber"
                          placeholder="Enter token number"
                          value={tokenNumber}
                          onChange={(e) => setTokenNumber(e.target.value)}
                          style={{
                            border: '1px solid #ced4da',
                            borderRadius: '8px',
                            fontSize: '1rem'
                          }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="comment" style={{ 
                          fontWeight: 'bold',
                          color: '#2c3e50',
                          marginBottom: '10px'
                        }}>
                          Additional Comments
                        </Label>
                        <Input
                          type="textarea"
                          name="comment"
                          id="comment"
                          rows="4"
                          placeholder="Enter any additional details, observations, or recommendations..."
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          style={{
                            border: '1px solid #ced4da',
                            borderRadius: '8px',
                            fontSize: '1rem'
                          }}
                        />
                      </FormGroup>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Submit Button */}
            <Row className="mt-4 justify-content-center">
              <Col xs="12" lg="10" className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  onClick={handleSubmit}
                  style={{
                    minWidth: windowWidth < 768 ? '150px' : '200px',
                    padding: windowWidth < 768 ? '10px 20px' : '12px 30px',
                    fontSize: windowWidth < 768 ? '1rem' : '1.1rem',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
                    width: windowWidth < 768 ? '100%' : 'auto'
                  }}
                >
                  Submit Report
                </Button>
              </Col>
            </Row>
          </Col>
        </Row> }
      </Container>
    </div>
  );
};

export default ViolationPage;